import { BoxWrapper, Modal } from 'components/Base';
import React, { useState } from 'react';
import Glossary from './Glossary';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const GlossaryLookup = ({ term }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const useStyles = makeStyles(() =>
    createStyles({
      modal: {
        width: '1000px',
        maxWidth: '90vw',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '80vh',
        overflow: 'auto'
      },
      item: {
        cursor: 'help',
        borderBottom: '1px dashed'
      }
    })
  );

  const classes = useStyles();

  return (
    <>
      <span
        title="View Glossary"
        onClick={() => setIsModalOpen(true)}
        className={classes.item}
      >
        {term}
      </span>
      <Modal
        isOpen={isModalOpen}
        closeModalFunc={() => {
          setIsModalOpen(false);
        }}
      >
        <BoxWrapper title="Glossary" closeModal={() => setIsModalOpen(false)}>
          <span className={classes.modal}>
            <Glossary term={term} />
          </span>
        </BoxWrapper>
      </Modal>
    </>
  );
};

export default GlossaryLookup;
